import React from 'react';

interface IProps {
	optionName: string;
}

export const OriginalSelection: React.FC<IProps> = (props) => {
	return <div className="original-selection">Originally: {props.optionName}</div>;
};
